
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, type Analytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDzXUgYSIufCktrf9VXKwoAKsqri5m80j4",
    authDomain: "mediocretoons.firebaseapp.com",
    projectId: "mediocretoons",
    storageBucket: "mediocretoons.firebasestorage.app",
    messagingSenderId: "359239828368",
    appId: "1:359239828368:web:fd5a5a53b4230083bee915",
    measurementId: "G-29NNE15XZM"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

let analytics: Analytics | null = null;
try {
    analytics = getAnalytics(app);
} catch {
    // Ambiente sem suporte (ex: SSR, testes)
}

export { auth, googleProvider, analytics };
